import { IWorkflowNode } from "motw_core/Entity/IWorkflowNode";
import * as React from "react";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Glyphicon from "source/app/presentation/Shared/Glyphicon/Glyphicon";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import { ToggleWorkflowNodeSelection } from "source/app/services/Workflows/WorkflowSelection";
import { GetWorkflowsState } from "source/app/presentation/MainPanel/Workflows/Workflows";

export function WorkflowNodeSelectToggle({
    node,
    isMultiSelectEnabled,
    isSelected,
}: {
    node: IWorkflowNode;
    isMultiSelectEnabled: boolean;
    isSelected: boolean;
}) {
    const workflows = GetWorkflowsState();

    if (!isMultiSelectEnabled || !workflows) {
        return null;
    }

    return (
        <span
            title="Select node for bulk delete"
            aria-pressed={isSelected}
            onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                ToggleWorkflowNodeSelection(node);
            }}
            className={StyleClass(`workflowNodeSelectToggle_${isSelected}`, {
                display: `inline-flex`,
                alignItems: `center`,
                justifyContent: `center`,
                position: `relative`,
                alignSelf: `start`,
                marginLeft: `0`,
                width: `52px`,
                padding: `0`,
                boxSizing: `border-box`,
                lineHeight: `inherit`,
                verticalAlign: `baseline`,
                cursor: `pointer`,
                touchAction: `manipulation`,
                userSelect: `none`,
                color: isSelected ? `greenyellow` : `#acacac`,
                opacity: isSelected ? 1 : 0.95,
                textShadow: isSelected
                    ? `0px 0px 10px rgba(173, 255, 47, 1)`
                    : `0px 0px 4px rgba(255, 255, 255, 0.35)`,
            })}
        >
            <span
                className={StyleClass(`workflowNodeSelectToggleBackground_${isSelected}`, {
                    position: `absolute`,
                    left: `4px`,
                    right: `4px`,
                    top: `50%`,
                    height: `18px`,
                    transform: `translateY(-50%)`,
                    borderRadius: `5px`,
                    background: isSelected
                        ? `rgba(173, 255, 47, 0.42)`
                        : `rgba(255, 255, 255, 0.08)`,
                    border: `1px solid ${isSelected ? `greenyellow` : `rgba(255,255,255,0.18)`}`,
                    boxShadow: isSelected
                        ? `0 0 7px rgba(173, 255, 47, 0.7)`
                        : `none`,
                    pointerEvents: `none`,
                })}
            />
            <span
                className={StyleClass(`workflowNodeSelectToggleIcon_${isSelected}`, {
                    position: `relative`,
                    zIndex: 1,
                    display: `inline-flex`,
                    alignItems: `center`,
                    justifyContent: `center`,
                    width: `12px`,
                    color: isSelected ? `#111` : `transparent`,
                    fontWeight: `bold`,
                })}
            >
                <Glyphicon icon={EGlyphicon.ok} />
            </span>
        </span>
    );
}
